/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_14Inputs */

const es_chat_suggestions_welcome_14 = /** @type {(inputs: Chat_Suggestions_Welcome_14Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Cómo puedo colaborar hoy, ${i?.name}?`)
};

const en_chat_suggestions_welcome_14 = /** @type {(inputs: Chat_Suggestions_Welcome_14Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`How can I support you today, ${i?.name}?`)
};

/**
* | output |
* | --- |
* | "How can I support you today, {name}?" |
*
* @param {Chat_Suggestions_Welcome_14Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_14 = /** @type {((inputs: Chat_Suggestions_Welcome_14Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_14Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_14(inputs)
	return en_chat_suggestions_welcome_14(inputs)
});
export { chat_suggestions_welcome_14 as "chat.suggestions.welcome_14" }